import Botonera from './botonera';
export default Botonera;